import React from 'react';
import Icon from '../../common/Icons';

const VARIANT_META = {
  success: { icon: 'checkCircle', label: 'Succès' },
  danger: { icon: 'exclamationTriangle', label: 'Erreur' },
  warning: { icon: 'exclamationCircle', label: 'Attention' },
  info: { icon: 'infoCircle', label: 'Information' }
};

/**
 * Pile de toasts réception — design IHM (simple, carte blanche, accent teal).
 */
export default function ReceptionToastStack({ toasts, onRemove, getDuration }) {
  if (!toasts.length) return null;

  return (
    <div className="recv-toast-stack recv-no-print" aria-live="polite" aria-atomic="false">
      {toasts.map((toast) => {
        const meta = VARIANT_META[toast.variant] || VARIANT_META.info;
        const durationMs = getDuration?.(toast.variant) ?? 5000;

        return (
          <div
            key={toast.id}
            className={`recv-toast recv-toast--${toast.variant}`}
            role="alert"
            onClick={() => onRemove(toast.id)}
          >
            <span className="recv-toast__icon" aria-hidden>
              <Icon name={meta.icon} size={18} />
            </span>
            <p className="recv-toast__message">{toast.message}</p>
            <button
              type="button"
              className="recv-toast__close"
              aria-label={`Fermer : ${meta.label}`}
              onClick={(event) => {
                event.stopPropagation();
                onRemove(toast.id);
              }}
            >
              <Icon name="times" size={14} />
            </button>
            <span
              className="recv-toast__progress"
              style={{ animationDuration: `${durationMs}ms` }}
              aria-hidden
            />
          </div>
        );
      })}
    </div>
  );
}
